export const partnersGovernmentdata = [
  {
    id: 1,
    type: "round",
    image: require("../Images/Partners/Government/AMARVATI.png"),
  },
  {
    id: 2,
    type: "round",
    image: require("../Images/Partners/Government/CDAC.png"),
  },
  {
    id: 3,
    type: "round",
    image: require("../Images/Partners/Government/CDOT.png"),
  },
  {
    id: 4,
    type: "round",
    image: require("../Images/Partners/Government/DRDO.png"),
  },
  {
    id: 5,
    type: "round",
    image: require("../Images/Partners/Government/NQM_LOGO.png"),
  },
  {
    id: 6,
    type: "round",
    image: require("../Images/Partners/Government/PVC.png"),
  },
  {
    id: 7,
    type: "round",
    image: require("../Images/Partners/Government/SSPL.png"),
  },
  {
    id: 8,
    type: "round",
    image: require("../Images/Partners/Government/TWORKS.png"),
  },
  {
    id: 9,
    type: "rectangle",
    image: require("../Images/Partners/Government/AMTZ.png"),
  },
  {
    id: 10,
    type: "rectangle",
    image: require("../Images/Partners/Government/DOT.png"),
  },
  {
    id: 11,
    type: "rectangle",
    image: require("../Images/Partners/Government/IHUB.png"),
  },
  {
    id: 12,
    type: "rectangle",
    image: require("../Images/Partners/Government/ISRO.png"),
  },
  {
    id: 13,
    type: "rectangle",
    image: require("../Images/Partners/Government/NPCI.png"),
  },
  {
    id: 14,
    type: "rectangle",
    image: require("../Images/Partners/Government/RTIH.png"),
  },
];

export const partnersIndustrydata = [
  {
    id: 1,
    type: "rectangle",
    image: require("../Images/Partners/Industry/ABB.png"),
  },
  {
    id: 2,
    type: "rectangle",
    image: require("../Images/Partners/Industry/Fluentgrif.png"),
  },
  {
    id: 3,
    type: "rectangle",
    image: require("../Images/Partners/Industry/Fortytwo.png"),
  },
  {
    id: 4,
    type: "rectangle",
    image: require("../Images/Partners/Industry/Inchfab.png"),
  },
  {
    id: 5,
    type: "rectangle",
    image: require("../Images/Partners/Industry/ionq.png"),
  },
  {
    id: 6,
    type: "rectangle",
    image: require("../Images/Partners/Industry/JPMorgan.png"),
  },
  {
    id: 7,
    type: "rectangle",
    image: require("../Images/Partners/Industry/MORGANSTANLEY.png"),
  },
  {
    id: 8,
    type: "rectangle",
    image: require("../Images/Partners/Industry/QCTRL.png"),
  },
  {
    id: 9,
    type: "rectangle",
    image: require("../Images/Partners/Industry/quantum.future .png"),
  },
  {
    id: 10,
    type: "rectangle",
    image: require("../Images/Partners/Industry/QUEST.png"),
  },
  {
    id: 11,
    type: "rectangle",
    image: require("../Images/Partners/Industry/SCYTALE.png"),
  },
  {
    id: 12,
    type: "rectangle",
    image: require("../Images/Partners/Industry/SM.jpg"),
  },
  {
    id: 13,
    type: "rectangle",
    image: require("../Images/Partners/Industry/VPG.png"),
  },
];

export const partnersAcademiadata = [
  {
    id: 1,
    type: "round",
    image: require("../Images/Partners/Academia/AIMSCS.jpg"),
  },
  {
    id: 2,
    type: "round",
    image: require("../Images/Partners/Academia/BITS.png"),
  },
  {
    id: 3,
    type: "round",
    image: require("../Images/Partners/Academia/GVP.jpg"),
  },
  {
    id: 4,
    type: "round",
    image: require("../Images/Partners/Academia/IITD.png"),
  },
  {
    id: 5,
    type: "round",
    image: require("../Images/Partners/Academia/IITH.png"),
  },
  {
    id: 6,
    type: "round",
    image: require("../Images/Partners/Academia/IITK.png"),
  },
  {
    id: 7,
    type: "round",
    image: require("../Images/Partners/Academia/IITM.png"),
  },
  {
    id: 8,
    type: "rectangle",
    image: require("../Images/Partners/Academia/AMRITA.png"),
  },
  {
    id: 9,
    type: "rectangle",
    image: require("../Images/Partners/Academia/ARIZONA.png"),
  },
  {
    id: 10,
    type: "rectangle",
    image: require("../Images/Partners/Academia/AU.png"),
  },
  {
    id: 11,
    type: "rectangle",
    image: require("../Images/Partners/Academia/BITSBIOCITY.png"),
  },
  {
    id: 12,
    type: "rectangle",
    image: require("../Images/Partners/Academia/GMRIT.png"),
  },
  {
    id: 13,
    type: "rectangle",
    image: require("../Images/Partners/Academia/IITT.png"),
  },
  {
    id: 14,
    type: "rectangle",
    image: require("../Images/Partners/Academia/PES.png"),
  },
  {
    id: 15,
    type: "rectangle",
    image: require("../Images/Partners/Academia/TCG.png"),
  },
];

export const partnerssimpledata = [
  {
    id: 1,
    name: "Full Spectrum Healthcare",
    content:
      "Their technology based human centric solutions have elevated our  ability to provide superior patient care and have empowered us to  continue our mission of providing top-notch healthcare automation  solutions to our clients. With Qulabs by our side, we can  focus on providing the best care to our patients, knowing that we've got  all other aspects covered.",
  },
  {
    id: 2,
    name: "Quantum RCM",
    content:
      "With their cutting-edge advanced analytics models, we've experienced a  substantial streamlining of our financial operations and a significant  reduction in administrative complexities. We wholeheartedly endorse  their services for any organization aiming to excel in revenue cycle  management.",
  },
  {
    id: 3,
    name: "Cellarian Inc.",
    content:
      "Qulabs's innovative solutions have not only streamlined our  processes but have also significantly improved the accuracy of our  medical necessity documentation. Their AI technology has played a  pivotal role in enhancing our support capabilities, making a notable  impact on our bottom line.",
  },
];
